module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp1_0.6699ad7c.png";